import { AppSettings } from '../../types';
import { VoiceStackService } from './voiceStackService';
import { validateSpokenReply } from './voiceGuards';

export class VoiceLabService {
  static async testBrain(settings: AppSettings) {
    const started = performance.now();
    const result = await VoiceStackService.generateTurn({
      apiKey: settings.openRouterKey,
      model: settings.defaultModel || 'openrouter/free',
      systemPrompt: 'Je bent een Nederlandse sales call agent. Geef alleen spreektekst terug, maximaal twee korte zinnen.',
      prompt: 'Lead zegt: "Ik heb nu weinig tijd, waar gaat dit over?" Reageer natuurlijk namens BDAT.',
    });
    const validation = validateSpokenReply(result.text);
    if (!validation.ok) throw new Error(validation.reason);
    return `Brain OK (${Math.round(performance.now() - started)}ms): ${validation.text}`;
  }

  static async testVoice() {
    const started = performance.now();
    const result = await VoiceStackService.synthesizeSpeech({
      text: 'Goedemiddag, u spreekt met Steve van BDAT. Bel ik gelegen voor een korte vraag?',
      provider: 'auto',
      language: 'nl',
    });
    return { audio: result.audio, message: `${result.provider} voice OK (${result.latencyMs || Math.round(performance.now() - started)}ms).` };
  }

  static async testVoxcpm() {
    const started = performance.now();
    const result = await VoiceStackService.testVoxcpm({
      voiceDesignPrompt: 'Nederlandse professionele sales consultant, warm, duidelijk, natuurlijk',
    });
    return {
      audio: result.audio,
      latencyMs: result.latencyMs || Math.round(performance.now() - started),
    };
  }

  static async testSupertonic(input: { voiceStyle: string; character: 'business' | 'free' }) {
    const started = performance.now();
    const text = input.character === 'business'
      ? 'Goedemiddag, u spreekt met BDAT. Ik bel kort en zakelijk met een vraag over mogelijke samenwerking.'
      : 'Hoi, u spreekt met BDAT. Ik bel even kort, gewoon om te kijken of dit interessant voor u kan zijn.';
    const result = await VoiceStackService.synthesizeSpeech({
      text,
      provider: 'supertonic',
      language: 'nl',
      voiceStyle: input.voiceStyle,
    });
    return {
      audio: result.audio,
      message: `Supertonic ${input.voiceStyle} ${input.character === 'business' ? 'zakelijk' : 'vrij'} OK (${result.latencyMs || Math.round(performance.now() - started)}ms).`,
    };
  }

  static async testBoson(input: { voice?: string; text?: string } = {}) {
    const started = performance.now();
    const result = await VoiceStackService.testBoson({
      text: input.text,
      voice: input.voice || 'nora',
    });
    return {
      audio: result.audio,
      message: `Boson Higgs (${input.voice || 'nora'}) OK (${result.latencyMs || Math.round(performance.now() - started)}ms).`,
    };
  }

  static async testFullLoop(settings: AppSettings) {
    const brain = await this.testBrain(settings);
    const voice = await this.testVoice();
    return { audio: voice.audio, message: `${brain} ${voice.message}` };
  }
}
